import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var MLSkillVersionsService = /** @class */ (function (_super) {
    tslib_1.__extends(MLSkillVersionsService, _super);
    function MLSkillVersionsService(http) {
        var _this = _super.call(this, http, MapperService.mlSkillVersionMap) || this;
        _this._endpoint = '/odata/MLSkillVersions';
        return _this;
    }
    MLSkillVersionsService.prototype.getVersions = function (mlSkillId, queryOptions) {
        return this.get(queryOptions, this._endpoint + "/UiPath.Server.Configuration.OData.GetMLSkillVersions(mlSkillId='" + mlSkillId + "')");
    };
    MLSkillVersionsService.prototype.updateVersion = function (mlSkillId, mlPackageVersionId, processor) {
        var payload = JSON.stringify({
            mlPackageVersionId: mlPackageVersionId,
            processor: processor,
        });
        return this._http.post(this._endpoint + "('" + mlSkillId + "')/UiPath.Server.Configuration.OData.UpdateMLSkillVersion", payload);
    };
    return MLSkillVersionsService;
}(ODataService));
export { MLSkillVersionsService };
